const state = {


    dispFilterLs:[],
    filterData:null,
    orgBindedFlightLs:null,
    BindedFlightLs:null,
    searchRes: null,

};

const getters = {


    GET_ORG_BINDED_FLIGHT_LS: (state) => {
        return state.orgBindedFlightLs;
    },
    
    GET_DISP_FILTER_LS: (state) => {
        return state.dispFilterLs;
    },
   
    GET_FILTER_DATA: (state) => {
        return state.filterData;
    },
    GET_BINDED_FLIGHT_LS: (state) => {
        return state.BindedFlightLs;
    },
    GET_SEARCH_RES: (state) => {
        return state.searchRes;
    },
};


const actions = {
    CLEAR_RESULT_STORE: ({ commit }) => {
        commit('clearResultStore');
    },
    SET_ORG_BINDED_FLIGHT_LS: ({ commit }, orgBindedFlightLs) => {
        commit('saveOrgBindedFlightLs', orgBindedFlightLs)
    },

    SET_DISP_FILTER_LS: ({ commit }, dispFilterLs) => {
        commit('saveDisplayFilterLs', dispFilterLs)
    },
    SET_FILTER_DATA: ({ commit }, filters) => {

        commit('saveFilterData', filters);

    },
    SET_BINDED_FLIGHT_LS: ({ commit }, BindedFlightLs) => {
        commit('saveBindedFlightLs', BindedFlightLs)
    },
    SET_SEARCH_RES: ({ commit }, searchRes) => {
        commit('saveSearchRes', searchRes)
    },

};


const mutations = {
    clearResultStore: (state) => {
        
        state.dispFilterLs=null;
        state.filterData=null;
        state.orgBindedFlightLs=null;
        state.BindedFlightLs=null;
        state.searchRes = null;

    },
   
    saveOrgBindedFlightLs: (state, orgBindedFlightLs) => {
        state.orgBindedFlightLs = orgBindedFlightLs;
    },
    saveDisplayFilterLs: (state, dispFilterLs) => {
        state.dispFilterLs = dispFilterLs;
    },
   
    saveFilterData: (state, filterData) => {
        state.filterData = filterData;
    },
    saveBindedFlightLs: (state, BindedFlightLs) => {
        state.BindedFlightLs = BindedFlightLs;
    },

    saveSearchRes: (state, searchRes) => {
        state.searchRes = searchRes;
    },

};


export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}